import styled, { css } from 'styled-components';
import { TabPanel } from '@chakra-ui/react';
import { Form } from '@unform/web';

interface MapViewPARAMS {
  ampliar: boolean;
}

export const Container = styled.div`
  flex: 1;
  display: flex;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
	padding: 3.9rem 1.5rem 5rem 5.5rem; // 4.42rem 1.5rem 5rem 5.5rem;
  // border: 2px solid red;

  .tabs {
    width: 100%;

    .tab-list {
      display: flex;

      .tab {
        font-size: 18px;
        font-weight: 500;

        :focus {
          box-shadow: 0 0 0 0;
          border: 0 0;
        };
      };
    };

    .tab-panels {
      width: 100%;
      height: 93.5%;
      position: relative;
      // border: 2px solid orange;

      .tab-panel {
        width: 100%;
        padding: 0;
      };
    };
  };

  // 767px
  @media (max-width: 47.9375rem) {
    margin-left: 0;
		padding: 4.3rem 0.5rem 5rem;
  };
	// 479px
  @media (max-width: 29.9375rem) {
		.tabs {
			.tab-list {
				.tab {
					font-size: 15px;
				};
			};
		};
	};
`;

export const TabsView = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  // border: 2px solid blue;

  > .tabs {
    > .tab-list {
      justify-content: center;
      align-items: center;
    }
  }
`;

export const TabLoja = styled(TabPanel)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow-y: scroll;
  width: 100%;
  height: 100%;
  margin-top: 20px;
`;

export const ImgInput = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 140px;
  height: 140px;
  border: 3px solid var(--gray-border-lg);
  border-style: dashed;
  border-radius: 50%;
  margin-bottom: 10px;

  img {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 130px;
    height: 130px;
    border-radius: 50%;
  }

  label {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    border-radius: 50%;
    border: 0;
    cursor: pointer;
    transition: background-color 0.2s;

    input {
      display: none;
    }

    svg {
      width: 25px;
      height: 25px;
      color: #312e38;
    }

    &:hover {
      filter: brightness(0.9);
    }
  }
  label.select-picture {
    width: 40px;
    height: 40px;
    background-color: rgba(26, 131, 255, 0.7); //  var(--azul-razio);
    right: -10px;
    bottom: 0px;

    svg {
      color: #fff;
      margin-bottom: 2px;
    }
  }
  label.remove-picture {
    width: 30px;
    height: 30px;
    background-color: rgba(176, 190, 197, 0.7); // var(--gray-border-md);
    top: 0px;
    right: -15px;

    svg {
      width: 20px;
      height: 20px;
      color: #312e38;
    }
  }
`;

export const FormView = styled(Form)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 70%;

  h1 {
    font-size: 26px;
    font-weight: 500;
  };

  div.input {
    display: flex;
    flex-direction: column;

    p {
      font-size: 1rem;
      font-weight: 500;
      margin: 15px 0 3px;

      span {
        font-size: 0.8rem;
        color: #455a64;
      }
    }

    span {
      font-size: 0.8rem;
      font-weight: 500;
      color: #455a64;
      text-align: end;
      width: 100%;
      padding: 5px 10px 0 0;
    }
  };

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    background-color: var(--azul-razio);
    color: #fff;
    width: 20%;
    padding: 10px 30px;
    margin: 20px 0;
    border: 1px solid var(--azul-razio);
    border-radius: 8px;
  }

	// 479px
  @media (max-width: 29.9375rem) {
		width: 98%;

		button {
			width: 100%;
		}
	};
`;

export const TabEndereco = styled(TabPanel)`
  display: flex;
  overflow-y: scroll;
  width: 100%;
  height: 100%;
  margin-top: 20px;

  .endereco {
    display: flex;
    flex-direction: column;
    padding: 10px 30px;
    width: 50%;
    height: 100%;
    // border: 2px solid red;

    h1 {
      font-size: 22px;
      font-weight: 500;
      padding: 5px 0;
    }
    h2 {
      font-size: 18px;
      padding: 5px 5px;
    }
    button {
      font-size: 18px;
      font-weight: 500;
      color: var(--azul-razio);
      border: 2px solid var(--azul-razio);
      border-radius: 8px;
      padding: 7px 30px;
      width: 50%;
      margin: 10px 0;
    }
  };

	// 479px
  @media (max-width: 29.9375rem) {
		flex-direction: column;

		.endereco {
			padding: 10px 5px;
			width: 100%;

			h1 {
				font-size: 20px;
			}
			h2 {
				font-size: 16px;
			}
			button {
				width: 100%;
			}
		};
	};
`;

export const MapView = styled.div<MapViewPARAMS>`
  display: flex;
  border: 2px dashed var(--gray-border-md);
  border-radius: 8px;
  z-index: 1;

	transition: width 1s, height 1s;

  .edit-endereco {
    background-color: #fff;
    position: absolute;
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
    top: 60px;
    left: 10px;
    z-index: 2;
    border-radius: 8px;
    padding: 10px;
    width: 450px;
    transition: opacity 1s, visibility 1s;
    //  border: 2px solid red;

    div.input {
      display: flex;
      flex-direction: column;

      p {
        font-size: 0.9rem;
        font-weight: 500;
        margin: 5px 0;

        span {
          font-size: 0.8rem;
          color: #455a64;
        }
      }

      span {
        font-size: 0.8rem;
        font-weight: 500;
        color: #455a64;
        text-align: end;
        width: 100%;
        padding: 5px 10px 0 0;
      }
    }

    h1 {
      font-size: 18px;
      font-weight: 500;
      padding: 5px;
    }

    > button {
      font-size: 16px;
      font-weight: 500;
      color: var(--azul-razio);
      border: 2px solid var(--azul-razio);
      border-radius: 8px;
      padding: 7px 30px;
      width: 100%;
      margin-top: 10px;
    }

    .new-end {
      display: flex;
      flex-direction: column;
      box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);
      padding: 10px;
      margin-top: 10px;
      border-radius: 10px;

      .btn-confirm {
        font-size: 16px;
        font-weight: 500;
        background-color: var(--azul-razio);
        color: #fff;
        border: 2px solid var(--azul-razio);
        border-radius: 8px;
        padding: 7px 30px;
        width: 100%;
        margin-top: 10px;
      }
    }
  }

  ${props =>
    props.ampliar
      ? css`
          width: 100%;
          height: 88vh;

          .edit-endereco {
            display: flex;
            flex-direction: column;
            opacity: 1;
          }
        `
      : css`
          width: 50%;
          height: 40vh;

          .edit-endereco {
            // display: none;
            visibility: hidden;
            opacity: 0;
          }
    `}

	// 479px
  @media (max-width: 29.9375rem) {
		.edit-endereco {
			top: 60px;
			left: 5px;
			padding: 10px;
			width: 97%;

			h1 {
				font-size: 16px;
			}

			.new-end {
				.btn-confirm {
					font-size: 14px;
					padding: 5px;
					width: 100%;
				}
			}
		}

		${props =>
		props.ampliar
			? css`
          width: 100%;
          height: 100vh;

          .edit-endereco {
            display: flex;
            flex-direction: column;
            opacity: 1;
          }
        `
			: css`
          width: 100%;
          height: 40vh;

          .edit-endereco {
            // display: none;
            visibility: hidden;
            opacity: 0;
          }
      `}
	};
`;

export const GestaoAcessos = styled(TabPanel)`
  display: flex;
  justify-content: center;
  overflow-y: scroll;
  width: 100%;
  height: 100%;
  margin-top: 20px;
`;

export const GestaoAcessosContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;

  > h1 {
    font-size: 20px;
  }
  > h2 {
    font-size: 18px;
    color: #546e7a;
  }

  .tabs {
    margin-top: 10px;

    .tab-panels {
      .tab-panel-content {
        display: flex;
        padding: 20px;

				button {
					display: flex;
					justify-content: center;
					align-items: center;
					color: var(--azul-razio);

					svg {
						font-size: 22px;
					}
				}
				button:first-child {
					margin-right: 10px;
				}

				.cards {
					visibility: hidden;
					display: none;
				}

        .table {
          font-size: 13px;
          font-weight: 500;

          .head {
            tr {
              th {
                font-size: 10px;
                color: #333;
              }
            }
          }
          .body {
            font-size: 13px;

            tr {
              td {
                color: #455a64;
              }

              .td-buttons {
                display: flex;
								align-items: center;
                width: 100%;
								height: 100%;
								margin-bottom: -1px;
              }
            }
          }
        }
      }
    }
  }

	// 479px
  @media (max-width: 29.9375rem) {
		width: 97%;

		> h1 {
			font-size: 16px;
		}
		> h2 {
			font-size: 14px;
		}
		
		.tabs {
			margin-top: 5px;

			.tab-panels {
				.tab-panel-content {
					padding: 10px 0px;

					button {
						svg {
							font-size: 18px;
						}
					};

					.table {
						visibility: hidden;
						display: none;
					};

					.cards {
						visibility: visible;
						display: block;
					};
				}
			}
		}
	}
`;

export const GestaoAcessoForm = styled(Form)`
  display: flex;
  justify-content: space-between;
  padding: 30px 0 20px;

  .gestao-div-input {
    display: flex;
    width: 50%;
  }
  .gestao-div-button {
    display: flex;

    button {
      font-size: 16px;
      font-weight: 500;
      background-color: var(--azul-razio);
      color: #fff;
      border: 2px solid var(--azul-razio);
      border-radius: 8px;
      padding: 7px 30px;
      width: 100%;
    }
  }

	// 479px
  @media (max-width: 29.9375rem) {
		flex-direction: column-reverse;
		padding: 10px 0 10px;

		.gestao-div-input {
			width: 100%;
			margin-top: 10px;
		};
		.gestao-div-button {
			button {
				font-size: 16px;
				padding: 7px 30px;
			}
		}
	}
`;
